// Permissions used in this application. This is a type to avoid typos for
// permission names.

export const AUTHORIZATION_SERVICES = [
  'fnds-group',
  'group-mapping',
  'identity-provider',
  'person',
  'tenant',
  'il4',
  'feature-flags',
  'mobile',
  'license',
  'blackboard.management',
  'client',
  'dda',
  'blackboard.sites',
  'blackboard.artifacts',
  'blackboard.fleets',
  'cohort',
  'query-tooling',
] as const;
export type AuthorizationService = (typeof AUTHORIZATION_SERVICES)[number];

export const AUTHORIZATION_PERMISSIONS = [
  'create',
  'delete',
  'read',
  'update',
  'access',
  'view',
  'search',
  'notification',
  'get',
  'execute',
] as const;
export type AuthorizationPermission = (typeof AUTHORIZATION_PERMISSIONS)[number];

export interface PermissionsApiResponse {
  permissions: string[];
}

export interface AudienceResult {
  audience: string;
  tenantId: string;
}

export interface PermissionResult {
  /**
   * Any error state occurring while permissions lookup was being done.
   */
  error?: Error;
  /**
   * Returns whether the current user has a particular permission according to the
   * authorization authority service. This is pessimistic by design; while the API
   * response is loading or if the API response failed, a false value is returned.
   */
  hasPermission: (service: AuthorizationService, permission: AuthorizationPermission) => boolean;
  /**
   * Are permissions being loaded from the API now?
   */
  loading: boolean;
  /**
   * All permissions the user has.
   */
  permissions: {
    service: AuthorizationService;
    permission: AuthorizationPermission;
  }[];
}

// Memoizing this outside the hook.
